module.exports = __webpack_public_path__ + "9fa9a1a97565b2c999e024d371f70bdc.svg";